import type { GroupingItem } from '@vedalib/editor/lib/elements'
import { FileUsageTypeEnum } from '@vedalib/editor/lib/files'
import lodash from 'lodash'
import { useContext } from 'use-context-selector'

import GroupingContext from 'components/Editor/EditorElements/elements/Grouping/GroupingContext'
import {
  borderRadiusContent,
  cardStyles,
} from 'components/Editor/EditorElements/elements/Grouping/helper'
import { useUrlByUsage } from 'utils/files'

import Mask from '../../Mask/Mask'
import * as s from './ScaledAnswer.module.scss'

interface IScaledAnswerProps {
  isCorrect?: boolean
  item: GroupingItem
  value: string
}

const ScaledAnswer = ({ isCorrect, item, value }: IScaledAnswerProps) => {
  // const img = useImageWithCrop(item.image) || undefined
  const { styles, feedback } = useContext(GroupingContext)
  const url = useUrlByUsage(item.image, FileUsageTypeEnum.image)
  const groupBorderWidth = parseInt(styles.group.borderWidth as string)
  const answerBorderWidth = parseInt(styles.answer.borderWidth as string)
  const borderDiff = groupBorderWidth - answerBorderWidth

  const transform = `translateY(${borderDiff}px) translateX(${borderDiff * 2}px)`

  return (
    <div
      className={s.item}
      data-grouping-id={value}
      style={{
        ...cardStyles,
        ...lodash.omit(styles.answer, ['borderColor']),
        backgroundImage: url && `url(${url})`,
        transform,
        top: -groupBorderWidth,
        left: -answerBorderWidth,
        // @ts-expect-error css vars
        '--translateX': `${-borderDiff}px`,
        '--translateY': `${-borderDiff}px`,
      }}
    >
      <div
        className={s.mask}
        style={{
          borderRadius: borderRadiusContent(styles.answer) || styles.answer.borderRadius,
        }}
      >
        <Mask
          borderRadius={borderRadiusContent(styles.answer) || styles.answer.borderRadius}
          feedback={feedback}
          isCorrect={isCorrect}
        />
      </div>
      <div className={s.label}>{item.label}</div>
    </div>
  )
}

export default ScaledAnswer
